var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25546",
    "data-name": "Group 25546",
    transform: "translate(-88 -163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25269",
    "data-name": "Group 25269",
    transform: "translate(-1168 -956)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25531",
    "data-name": "Group 25531",
    transform: "translate(12582 -6678.207)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7379",
    "data-name": "Path 7379",
    d: "M702.96,1039.661H691.12a.947.947,0,1,0,0,1.894h11.838a.947.947,0,0,0,0-1.894Z",
    transform: "translate(-13177.171 5812.075)",
    fill: "#7f8a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7418",
    "data-name": "Path 7418",
    d: "M702.96,1039.661H691.12a.947.947,0,1,0,0,1.894h11.838a.947.947,0,0,0,0-1.894Z",
    transform: "translate(-13177.171 5817.445)",
    fill: "#7f8a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7417",
    "data-name": "Path 7417",
    d: "M702.96,1039.661H691.12a.947.947,0,1,0,0,1.894h11.838a.947.947,0,0,0,0-1.894Z",
    transform: "translate(-13177.171 5806.546)",
    fill: "#7f8a90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_2",
    "data-name": "Union 2",
    d: "M1.05,1.894H1V0h.05a.947.947,0,1,1,0,1.894Zm-.1,0h0A.947.947,0,1,1,.95,0H1V1.894Z",
    transform: "translate(-12492 6846.207)",
    fill: "#7f8a90",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_3",
    "data-name": "Union 3",
    d: "M1.05,1.894H1V0h.05a.947.947,0,1,1,0,1.894Zm-.1,0h0A.947.947,0,1,1,.95,0H1V1.894Z",
    transform: "translate(-12492 6851.736)",
    fill: "#7f8a90",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_4",
    "data-name": "Union 4",
    d: "M1.05,1.894H1V0h.05a.947.947,0,1,1,0,1.894Zm-.1,0h0A.947.947,0,1,1,.95,0H1V1.894Z",
    transform: "translate(-12492 6857.106)",
    fill: "#7f8a90",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list-icon.1f9099d8ebeb23cebf076edb5a05dfcd.svg";
export { ForwardRef as ReactComponent };